export default "__VITE_ASSET__C2NcVVLe__"